import { palette } from 'theme/palette';

import { TBadgeTone } from './Badge.types';

/**
 * Solid badges are a bright fill carrying ink text (the same relationship as the
 * primary button), so every tone clears 4.5:1 without inventing a per-tone text colour.
 * Soft badges are a 16% tint of the tone behind the tone at full strength.
 */
export const BADGE_TONES: Record<TBadgeTone, { solid: string; softFg: string; softBg: string }> = {
  success: {
    solid: palette.green500,
    softFg: palette.green500,
    softBg: 'rgba(51, 174, 121, 0.16)',
  },
  warning: {
    solid: palette.amber400,
    softFg: palette.amber400,
    softBg: 'rgba(245, 176, 62, 0.16)',
  },
  danger: { solid: palette.red500, softFg: palette.red400, softBg: 'rgba(240, 73, 46, 0.16)' },
  neutral: {
    solid: palette.slate400,
    softFg: palette.grey300,
    softBg: 'rgba(168, 168, 190, 0.16)',
  },
  muted: { solid: palette.slate400, softFg: palette.grey350, softBg: 'rgba(153, 153, 174, 0.16)' },
  brand: { solid: palette.teal500, softFg: palette.teal500, softBg: 'rgba(25, 227, 207, 0.16)' },
  info: { solid: palette.cyan400, softFg: palette.cyan400, softBg: 'rgba(34, 211, 238, 0.16)' },
};
